// generated with https://csvjson.com/csv2json from combined spreadsheet

import { operations } from "./openapi/generated-types.ts";

type CreatePlayer =
  operations["player.write.create"]["requestBody"]["content"]["application/json"];

export const players: (Omit<CreatePlayer, "teamId" | "id"> & {
  teamShortName: string;
})[] = [
  {
    number: 1,
    firstName: "Helene",
    lastName: "Hoffmann",
    birthday: "2011-02-02",
    isGoalkeeper: true,
    teamShortName: "svw",
  },
  {
    number: 3,
    firstName: "Greta",
    lastName: "Lauerer",
    birthday: "2011-07-23",
    isGoalkeeper: false,
    teamShortName: "svw",
  },
  {
    number: 4,
    firstName: "Talia",
    lastName: "Kanbur",
    birthday: "2011-09-11",
    isGoalkeeper: false,
    teamShortName: "svw",
  },
  {
    number: 5,
    firstName: "Ida",
    lastName: "Brugner",
    birthday: "2011-01-17",
    isGoalkeeper: false,
    teamShortName: "svw",
  },
  {
    number: 6,
    firstName: "Theresa",
    lastName: "Töpfer",
    birthday: "2011-08-29",
    isGoalkeeper: false,
    teamShortName: "svw",
  },
  {
    number: 7,
    firstName: "Enja",
    lastName: "Lohmann",
    birthday: "2011-02-22",
    isGoalkeeper: false,
    teamShortName: "svw",
  },
  {
    number: 10,
    firstName: "Edda",
    lastName: "Wilden",
    birthday: "2011-04-21",
    isGoalkeeper: false,
    teamShortName: "svw",
  },
  {
    number: 11,
    firstName: "Pia-Marie",
    lastName: "Arlinghaus",
    birthday: "2012-04-07",
    isGoalkeeper: false,
    teamShortName: "svw",
  },
  {
    number: 13,
    firstName: "Lisbet",
    lastName: "Linge",
    birthday: "2011-06-22",
    isGoalkeeper: false,
    teamShortName: "svw",
  },
  {
    number: 15,
    firstName: "Lia",
    lastName: "Kraszczynski",
    birthday: "2012-10-29",
    isGoalkeeper: false,
    teamShortName: "svw",
  },
  {
    number: 18,
    firstName: "Melissa",
    lastName: "Lühning",
    birthday: "2011-05-17",
    isGoalkeeper: false,
    teamShortName: "svw",
  },
  {
    number: 22,
    firstName: "Kalissa",
    lastName: "Knaut",
    birthday: "2011-06-21",
    isGoalkeeper: false,
    teamShortName: "svw",
  },
  {
    number: 23,
    firstName: "Janna",
    lastName: "Behrmann",
    birthday: "2012-02-13",
    isGoalkeeper: false,
    teamShortName: "svw",
  },
  {
    number: 24,
    firstName: "Daike",
    lastName: "Bolten",
    birthday: "2011-10-09",
    isGoalkeeper: false,
    teamShortName: "svw",
  },
  {
    number: 25,
    firstName: "Frida",
    lastName: "Lotte",
    birthday: "2011-02-14",
    isGoalkeeper: false,
    teamShortName: "svw",
  },
  {
    number: 26,
    firstName: "Adea",
    lastName: "Aliu",
    birthday: "2011-11-26",
    isGoalkeeper: false,
    teamShortName: "svw",
  },
  {
    number: 1,
    firstName: "Nele",
    lastName: "Eiche",
    birthday: "2011-08-15",
    isGoalkeeper: false,
    teamShortName: "scf",
  },
  {
    number: 2,
    firstName: "Emma",
    lastName: "Röttele",
    birthday: "2011-03-24",
    isGoalkeeper: false,
    teamShortName: "scf",
  },
  {
    number: 3,
    firstName: "Alena",
    lastName: "Gmelin",
    birthday: "2011-05-07",
    isGoalkeeper: false,
    teamShortName: "scf",
  },
  {
    number: 4,
    firstName: "Mailine",
    lastName: "Dattler",
    birthday: "2012-12-08",
    isGoalkeeper: false,
    teamShortName: "scf",
  },
  {
    number: 5,
    firstName: "Louisa Sophie",
    lastName: "Lissner",
    birthday: "2011-05-20",
    isGoalkeeper: false,
    teamShortName: "scf",
  },
  {
    number: 6,
    firstName: "Juliane",
    lastName: "Sabrowski",
    birthday: "2011-08-04",
    isGoalkeeper: false,
    teamShortName: "scf",
  },
  {
    number: 7,
    firstName: "Louisa",
    lastName: "Binder",
    birthday: "2012-09-07",
    isGoalkeeper: false,
    teamShortName: "scf",
  },
  {
    number: 8,
    firstName: "Romy",
    lastName: "Erlemann",
    birthday: "2012-08-19",
    isGoalkeeper: false,
    teamShortName: "scf",
  },
  {
    number: 9,
    firstName: "Helen Marie",
    lastName: "Oberfell",
    birthday: "2012-01-21",
    isGoalkeeper: false,
    teamShortName: "scf",
  },
  {
    number: 10,
    firstName: "Elisa",
    lastName: "Hoffmann",
    birthday: "2011-09-12",
    isGoalkeeper: false,
    teamShortName: "scf",
  },
  {
    number: 11,
    firstName: "Amelie",
    lastName: "Krieger",
    birthday: "2012-04-27",
    isGoalkeeper: false,
    teamShortName: "scf",
  },
  {
    number: 12,
    firstName: "Clarissa",
    lastName: "Monnheimer",
    birthday: "2011-01-03",
    isGoalkeeper: false,
    teamShortName: "scf",
  },
  {
    number: 13,
    firstName: "Marlene",
    lastName: "Bayer",
    birthday: "2012-08-29",
    isGoalkeeper: false,
    teamShortName: "scf",
  },
  {
    number: 14,
    firstName: "Romy",
    lastName: "Schiborr",
    birthday: "2011-01-12",
    isGoalkeeper: false,
    teamShortName: "scf",
  },
  {
    number: 15,
    firstName: "Tabea",
    lastName: "Müller",
    birthday: "2012-12-17",
    isGoalkeeper: false,
    teamShortName: "scf",
  },
  {
    number: 1,
    firstName: "Lea",
    lastName: "Spykermann",
    birthday: "2011-06-03",
    isGoalkeeper: false,
    teamShortName: "gsc",
  },
  {
    number: 2,
    firstName: "Lotte",
    lastName: "Droste",
    birthday: "2010-10-30",
    isGoalkeeper: false,
    teamShortName: "gsc",
  },
  {
    number: 3,
    firstName: "Miriam",
    lastName: "Olfert",
    birthday: "2012-06-30",
    isGoalkeeper: false,
    teamShortName: "gsc",
  },
  {
    number: 4,
    firstName: "Thyra",
    lastName: "Graß",
    birthday: "2011-10-26",
    isGoalkeeper: false,
    teamShortName: "gsc",
  },
  {
    number: 5,
    firstName: "Louisa",
    lastName: "Kolb",
    birthday: "2012-08-08",
    isGoalkeeper: false,
    teamShortName: "gsc",
  },
  {
    number: 6,
    firstName: "Felipa",
    lastName: "Schellinger",
    birthday: "2011-03-11",
    isGoalkeeper: false,
    teamShortName: "gsc",
  },
  {
    number: 7,
    firstName: "Özgü",
    lastName: "Küccülü",
    birthday: "2010-01-12",
    isGoalkeeper: false,
    teamShortName: "gsc",
  },
  {
    number: 8,
    firstName: "Lina",
    lastName: "Meynert",
    birthday: "2012-10-20",
    isGoalkeeper: false,
    teamShortName: "gsc",
  },
  {
    number: 9,
    firstName: "Mia",
    lastName: "Kittel",
    birthday: "2012-06-26",
    isGoalkeeper: false,
    teamShortName: "gsc",
  },
  {
    number: 10,
    firstName: "Liv",
    lastName: "Cholewa",
    birthday: "2011-10-30",
    isGoalkeeper: false,
    teamShortName: "gsc",
  },
  {
    number: 11,
    firstName: "Marie",
    lastName: "Wiens",
    birthday: "2010-10-15",
    isGoalkeeper: false,
    teamShortName: "gsc",
  },
  {
    number: 12,
    firstName: "Nele",
    lastName: "Thiesing",
    birthday: "2011-02-01",
    isGoalkeeper: false,
    teamShortName: "gsc",
  },
  {
    number: 13,
    firstName: "Lotta",
    lastName: "Horstmann",
    birthday: "2010-05-11",
    isGoalkeeper: false,
    teamShortName: "gsc",
  },
  {
    number: 14,
    firstName: "Frauke",
    lastName: "Wolter",
    birthday: "2012-02-26",
    isGoalkeeper: false,
    teamShortName: "gsc",
  },
  {
    number: 15,
    firstName: "Marlene",
    lastName: "Albrecht",
    birthday: "2011-04-16",
    isGoalkeeper: false,
    teamShortName: "gsc",
  },
  {
    number: 17,
    firstName: "Liv",
    lastName: "Miege",
    birthday: "2010-10-28",
    isGoalkeeper: false,
    teamShortName: "gsc",
  },
  {
    number: 21,
    firstName: "Madita",
    lastName: "Pannen",
    birthday: "2012-03-12",
    isGoalkeeper: false,
    teamShortName: "gsc",
  },
  {
    number: 1,
    firstName: "Nele",
    lastName: "Henkel",
    birthday: "2011-07-01",
    isGoalkeeper: true,
    teamShortName: "sgs",
  },
  {
    number: 12,
    firstName: "Medina",
    lastName: "Beric",
    birthday: "2012-10-04",
    isGoalkeeper: true,
    teamShortName: "sgs",
  },
  {
    number: 2,
    firstName: "Julia",
    lastName: "Günnewig",
    birthday: "2011-03-25",
    isGoalkeeper: false,
    teamShortName: "sgs",
  },
  {
    number: 5,
    firstName: "Thea",
    lastName: "Kamann",
    birthday: "2011-03-28",
    isGoalkeeper: false,
    teamShortName: "sgs",
  },
  {
    number: 6,
    firstName: "Tilda",
    lastName: "Lukas",
    birthday: "2012-10-15",
    isGoalkeeper: false,
    teamShortName: "sgs",
  },
  {
    number: 7,
    firstName: "Theresa",
    lastName: "Cordes",
    birthday: "2011-08-16",
    isGoalkeeper: false,
    teamShortName: "sgs",
  },
  {
    number: 9,
    firstName: "Eda",
    lastName: "Yalcin",
    birthday: "2012-01-15",
    isGoalkeeper: false,
    teamShortName: "sgs",
  },
  {
    number: 10,
    firstName: "Lusia",
    lastName: "Muthmann",
    birthday: "2011-05-08",
    isGoalkeeper: false,
    teamShortName: "sgs",
  },
  {
    number: 13,
    firstName: "Leni",
    lastName: "Wanhoff",
    birthday: "2011-04-20",
    isGoalkeeper: false,
    teamShortName: "sgs",
  },
  {
    number: 14,
    firstName: "Elifnaz",
    lastName: "Vurucu",
    birthday: "2011-02-22",
    isGoalkeeper: false,
    teamShortName: "sgs",
  },
  {
    number: 15,
    firstName: "Talia",
    lastName: "Mermetias",
    birthday: "2011-05-15",
    isGoalkeeper: false,
    teamShortName: "sgs",
  },
  {
    number: 21,
    firstName: "Derya",
    lastName: "Berwari",
    birthday: "2011-12-09",
    isGoalkeeper: false,
    teamShortName: "sgs",
  },
  {
    number: 22,
    firstName: "Ceylin",
    lastName: "Gül",
    birthday: "2011-09-19",
    isGoalkeeper: false,
    teamShortName: "sgs",
  },
  {
    number: 1,
    firstName: "Ylvie",
    lastName: "Kleimann",
    birthday: "2011-05-30",
    isGoalkeeper: false,
    teamShortName: "fsv",
  },
  {
    number: 2,
    firstName: "Ida",
    lastName: "Wilmes",
    birthday: "2011-10-24",
    isGoalkeeper: false,
    teamShortName: "fsv",
  },
  {
    number: 3,
    firstName: "Nele",
    lastName: "Burstein",
    birthday: "2011-02-17",
    isGoalkeeper: false,
    teamShortName: "fsv",
  },
  {
    number: 4,
    firstName: "Jarla",
    lastName: "Kriener",
    birthday: "2011-08-20",
    isGoalkeeper: false,
    teamShortName: "fsv",
  },
  {
    number: 5,
    firstName: "Fejola",
    lastName: "Borshille",
    birthday: "2011-08-07",
    isGoalkeeper: false,
    teamShortName: "fsv",
  },
  {
    number: 6,
    firstName: "Antonia",
    lastName: "Böhner",
    birthday: "2011-10-27",
    isGoalkeeper: false,
    teamShortName: "fsv",
  },
  {
    number: 7,
    firstName: "Lara",
    lastName: "Gebes",
    birthday: "2011-02-06",
    isGoalkeeper: false,
    teamShortName: "fsv",
  },
  {
    number: 8,
    firstName: "Ida",
    lastName: "Starke",
    birthday: "2011-05-10",
    isGoalkeeper: false,
    teamShortName: "fsv",
  },
  {
    number: 9,
    firstName: "Nisa",
    lastName: "Ismail",
    birthday: "2011-04-19",
    isGoalkeeper: false,
    teamShortName: "fsv",
  },
  {
    number: 10,
    firstName: "Samar",
    lastName: "Mathpoud",
    birthday: "2011-05-01",
    isGoalkeeper: false,
    teamShortName: "fsv",
  },
  {
    number: 11,
    firstName: "Merve",
    lastName: "Öcal",
    birthday: "2011-06-16",
    isGoalkeeper: false,
    teamShortName: "fsv",
  },
  {
    number: 12,
    firstName: "Lotta",
    lastName: "Sudkemper",
    birthday: "2011-06-18",
    isGoalkeeper: false,
    teamShortName: "fsv",
  },
  {
    number: 15,
    firstName: "Lilly",
    lastName: "Krahner",
    birthday: "2011-07-05",
    isGoalkeeper: false,
    teamShortName: "fsv",
  },
  {
    number: 17,
    firstName: "Theresa",
    lastName: "Schielke",
    birthday: "2011-10-12",
    isGoalkeeper: false,
    teamShortName: "fsv",
  },
  {
    number: 19,
    firstName: "Leandra",
    lastName: "Stienhans",
    birthday: "2011-07-20",
    isGoalkeeper: false,
    teamShortName: "fsv",
  },
  {
    number: 33,
    firstName: "Andrijana",
    lastName: "Perlovic",
    birthday: "2011-06-18",
    isGoalkeeper: false,
    teamShortName: "fsv",
  },
  {
    number: 1,
    firstName: "Anna Minou",
    lastName: "Von Papen",
    birthday: "2012-12-13",
    isGoalkeeper: false,
    teamShortName: "koe",
  },
  {
    number: 2,
    firstName: "Nalia Therese",
    lastName: "Zabel",
    birthday: "2012-04-14",
    isGoalkeeper: false,
    teamShortName: "koe",
  },
  {
    number: 3,
    firstName: "Thea Paula",
    lastName: "Lampe",
    birthday: "2011-06-27",
    isGoalkeeper: false,
    teamShortName: "koe",
  },
  {
    number: 4,
    firstName: "Ella",
    lastName: "Herrmann",
    birthday: "2012-11-10",
    isGoalkeeper: false,
    teamShortName: "koe",
  },
  {
    number: 5,
    firstName: "Emma Yivi",
    lastName: "Switalla",
    birthday: "2012-06-12",
    isGoalkeeper: false,
    teamShortName: "koe",
  },
  {
    number: 6,
    firstName: "Leonie",
    lastName: "Klings",
    birthday: "2011-10-02",
    isGoalkeeper: false,
    teamShortName: "koe",
  },
  {
    number: 7,
    firstName: "Magdalena",
    lastName: "Schmidt",
    birthday: "2011-01-07",
    isGoalkeeper: false,
    teamShortName: "koe",
  },
  {
    number: 8,
    firstName: "Reka",
    lastName: "Riola",
    birthday: "2011-01-23",
    isGoalkeeper: false,
    teamShortName: "koe",
  },
  {
    number: 9,
    firstName: "Emily",
    lastName: "Moser",
    birthday: "2011-12-22",
    isGoalkeeper: false,
    teamShortName: "koe",
  },
  {
    number: 10,
    firstName: "Tara",
    lastName: "Lohaj",
    birthday: "2011-08-10",
    isGoalkeeper: false,
    teamShortName: "koe",
  },
  {
    number: 11,
    firstName: "Jana",
    lastName: "Stellwach",
    birthday: "2012-09-14",
    isGoalkeeper: false,
    teamShortName: "koe",
  },
  {
    number: 13,
    firstName: "Nora",
    lastName: "Boumloud",
    birthday: "2012-02-06",
    isGoalkeeper: false,
    teamShortName: "koe",
  },
  {
    number: 14,
    firstName: "Delia Maren",
    lastName: "Karbe",
    birthday: "2012-05-04",
    isGoalkeeper: false,
    teamShortName: "koe",
  },
  {
    number: 15,
    firstName: "Aela",
    lastName: "Zeka",
    birthday: "2012-02-10",
    isGoalkeeper: false,
    teamShortName: "koe",
  },
  {
    number: 16,
    firstName: "Melina",
    lastName: "Muranyi",
    birthday: "2012-01-28",
    isGoalkeeper: false,
    teamShortName: "koe",
  },
  {
    number: 17,
    firstName: "Silvie",
    lastName: "Kempes",
    birthday: "2012-09-26",
    isGoalkeeper: false,
    teamShortName: "koe",
  },
  {
    number: 18,
    firstName: "Lia",
    lastName: "Johann",
    birthday: "2012-03-31",
    isGoalkeeper: false,
    teamShortName: "koe",
  },
  {
    number: 19,
    firstName: "Ida",
    lastName: "Breuer",
    birthday: "2012-06-08",
    isGoalkeeper: false,
    teamShortName: "koe",
  },
  {
    number: 20,
    firstName: "Emily",
    lastName: "Beyert",
    birthday: "2012-04-13",
    isGoalkeeper: false,
    teamShortName: "koe",
  },
  {
    number: 21,
    firstName: "Paulina",
    lastName: "Schier",
    birthday: "2012-08-01",
    isGoalkeeper: false,
    teamShortName: "koe",
  },
  {
    number: 1,
    firstName: "Yasmina",
    lastName: "Spangenberg",
    birthday: "2012-05-22",
    isGoalkeeper: true,
    teamShortName: "pot",
  },
  {
    number: 12,
    firstName: "Lotta",
    lastName: "Helfenstein",
    birthday: "2011-11-29",
    isGoalkeeper: true,
    teamShortName: "pot",
  },
  {
    number: 3,
    firstName: "Nina",
    lastName: "Kiwall",
    birthday: "2012-02-06",
    isGoalkeeper: false,
    teamShortName: "pot",
  },
  {
    number: 4,
    firstName: "Helena",
    lastName: "Suske",
    birthday: "2012-03-28",
    isGoalkeeper: false,
    teamShortName: "pot",
  },
  {
    number: 5,
    firstName: "Carlotta",
    lastName: "Piel",
    birthday: "2011-06-19",
    isGoalkeeper: false,
    teamShortName: "pot",
  },
  {
    number: 6,
    firstName: "Romy",
    lastName: "Zoschke",
    birthday: "2011-02-02",
    isGoalkeeper: false,
    teamShortName: "pot",
  },
  {
    number: 7,
    firstName: "Inka",
    lastName: "Krogmann",
    birthday: "2012-10-08",
    isGoalkeeper: false,
    teamShortName: "pot",
  },
  {
    number: 8,
    firstName: "Leonie",
    lastName: "Schauksdat",
    birthday: "2011-12-08",
    isGoalkeeper: false,
    teamShortName: "pot",
  },
  {
    number: 9,
    firstName: "Ruby",
    lastName: "Klein",
    birthday: "2012-02-06",
    isGoalkeeper: false,
    teamShortName: "pot",
  },
  {
    number: 10,
    firstName: "Leni",
    lastName: "Pieper",
    birthday: "2012-01-12",
    isGoalkeeper: false,
    teamShortName: "pot",
  },
  {
    number: 11,
    firstName: "Karlotta",
    lastName: "Piontek",
    birthday: "2011-09-19",
    isGoalkeeper: false,
    teamShortName: "pot",
  },
  {
    number: 14,
    firstName: "Eny",
    lastName: "Zittlau",
    birthday: "2013-05-30",
    isGoalkeeper: false,
    teamShortName: "pot",
  },
  {
    number: 15,
    firstName: "Zeruja",
    lastName: "Barthel",
    birthday: "2011-11-04",
    isGoalkeeper: false,
    teamShortName: "pot",
  },
  {
    number: 16,
    firstName: "Hannah",
    lastName: "Wegner",
    birthday: "2012-07-09",
    isGoalkeeper: false,
    teamShortName: "pot",
  },
  {
    number: 17,
    firstName: "Luzie",
    lastName: "Neidnicht",
    birthday: "2012-04-28",
    isGoalkeeper: false,
    teamShortName: "pot",
  },
  {
    number: 19,
    firstName: "Lilly",
    lastName: "Feist",
    birthday: "2011-08-19",
    isGoalkeeper: false,
    teamShortName: "pot",
  },
  {
    number: 1,
    firstName: "Mahla",
    lastName: "Straut",
    birthday: "2012-10-12",
    isGoalkeeper: false,
    teamShortName: "sge",
  },
  {
    number: 2,
    firstName: "Jara",
    lastName: "Osmani",
    birthday: "2013-01-17",
    isGoalkeeper: false,
    teamShortName: "sge",
  },
  {
    number: 4,
    firstName: "Clara",
    lastName: "Rachor",
    birthday: "2012-12-05",
    isGoalkeeper: false,
    teamShortName: "sge",
  },
  {
    number: 5,
    firstName: "Valerie",
    lastName: "Fendrich",
    birthday: "2011-09-21",
    isGoalkeeper: false,
    teamShortName: "sge",
  },
  {
    number: 6,
    firstName: "Charlotte",
    lastName: "Rudzinski",
    birthday: "2013-03-30",
    isGoalkeeper: false,
    teamShortName: "sge",
  },
  {
    number: 7,
    firstName: "Sophie",
    lastName: "Behrendt",
    birthday: "2012-02-04",
    isGoalkeeper: false,
    teamShortName: "sge",
  },
  {
    number: 8,
    firstName: "Emma",
    lastName: "Limbrunner",
    birthday: "2012-02-22",
    isGoalkeeper: false,
    teamShortName: "sge",
  },
  {
    number: 9,
    firstName: "Marie",
    lastName: "Riebenstahl",
    birthday: "2012-09-08",
    isGoalkeeper: false,
    teamShortName: "sge",
  },
  {
    number: 12,
    firstName: "Amelie",
    lastName: "Joachim",
    birthday: "2012-07-17",
    isGoalkeeper: false,
    teamShortName: "sge",
  },
  {
    number: 14,
    firstName: "Alessia",
    lastName: "Capobianco",
    birthday: "2011-11-08",
    isGoalkeeper: false,
    teamShortName: "sge",
  },
  {
    number: 15,
    firstName: "Alifa",
    lastName: "Touhami",
    birthday: "2012-06-17",
    isGoalkeeper: false,
    teamShortName: "sge",
  },
  {
    number: 16,
    firstName: "Melia",
    lastName: "Neumayer",
    birthday: "2012-09-06",
    isGoalkeeper: false,
    teamShortName: "sge",
  },
  {
    number: 18,
    firstName: "Merle",
    lastName: "Rother",
    birthday: "2012-12-21",
    isGoalkeeper: false,
    teamShortName: "sge",
  },
  {
    number: 21,
    firstName: "Mia",
    lastName: "Duric",
    birthday: "2012-09-04",
    isGoalkeeper: false,
    teamShortName: "sge",
  },
  {
    number: 24,
    firstName: "Ines",
    lastName: "Streit",
    birthday: "2012-07-05",
    isGoalkeeper: false,
    teamShortName: "sge",
  },
  {
    number: 1,
    firstName: "Julienne",
    lastName: "Loyal",
    birthday: "2011-01-17",
    isGoalkeeper: false,
    teamShortName: "tsg",
  },
  {
    number: 3,
    firstName: "Romy",
    lastName: "Nagel",
    birthday: "2011-09-25",
    isGoalkeeper: false,
    teamShortName: "tsg",
  },
  {
    number: 4,
    firstName: "Marie",
    lastName: "Bauer",
    birthday: "2012-02-22",
    isGoalkeeper: false,
    teamShortName: "tsg",
  },
  {
    number: 5,
    firstName: "Emma",
    lastName: "Kümmerling",
    birthday: "2011-06-29",
    isGoalkeeper: false,
    teamShortName: "tsg",
  },
  {
    number: 6,
    firstName: "Maxime",
    lastName: "Stauch",
    birthday: "2011-02-12",
    isGoalkeeper: false,
    teamShortName: "tsg",
  },
  {
    number: 7,
    firstName: "Marlene",
    lastName: "Rüeck",
    birthday: "2011-02-09",
    isGoalkeeper: false,
    teamShortName: "tsg",
  },
  {
    number: 8,
    firstName: "Matilda",
    lastName: "Wolf",
    birthday: "2011-08-02",
    isGoalkeeper: false,
    teamShortName: "tsg",
  },
  {
    number: 9,
    firstName: "Kya",
    lastName: "Staisch",
    birthday: "2011-05-01",
    isGoalkeeper: false,
    teamShortName: "tsg",
  },
  {
    number: 10,
    firstName: "Marie",
    lastName: "Kling",
    birthday: "2011-07-04",
    isGoalkeeper: false,
    teamShortName: "tsg",
  },
  {
    number: 11,
    firstName: "Frieda",
    lastName: "Moßmann",
    birthday: "2011-03-07",
    isGoalkeeper: false,
    teamShortName: "tsg",
  },
  {
    number: 12,
    firstName: "Alicia",
    lastName: "Zongola",
    birthday: "2012-08-06",
    isGoalkeeper: false,
    teamShortName: "tsg",
  },
  {
    number: 13,
    firstName: "Scarlett",
    lastName: "Arnold",
    birthday: "2011-04-26",
    isGoalkeeper: false,
    teamShortName: "tsg",
  },
  {
    number: 14,
    firstName: "Ida",
    lastName: "Lerner",
    birthday: "2012-09-12",
    isGoalkeeper: false,
    teamShortName: "tsg",
  },
  {
    number: 15,
    firstName: "Mia",
    lastName: "Hudap",
    birthday: "2012-12-18",
    isGoalkeeper: false,
    teamShortName: "tsg",
  },
  {
    number: 17,
    firstName: "Cilia",
    lastName: "Thurecht",
    birthday: "2011-04-21",
    isGoalkeeper: false,
    teamShortName: "tsg",
  },
  {
    number: 18,
    firstName: "Aimee-Lou",
    lastName: "Kiermeier",
    birthday: "2011-03-18",
    isGoalkeeper: false,
    teamShortName: "tsg",
  },
  {
    number: 19,
    firstName: "Emilia",
    lastName: "Moser",
    birthday: "2011-07-05",
    isGoalkeeper: false,
    teamShortName: "tsg",
  },
  {
    number: 21,
    firstName: "Mira",
    lastName: "Sanchez",
    birthday: "2011-04-03",
    isGoalkeeper: false,
    teamShortName: "tsg",
  },
  {
    number: 22,
    firstName: "Emma",
    lastName: "Klapp",
    birthday: "2012-02-09",
    isGoalkeeper: false,
    teamShortName: "tsg",
  },
  {
    number: 23,
    firstName: "Laura",
    lastName: "Novackova",
    birthday: "2011-07-19",
    isGoalkeeper: false,
    teamShortName: "tsg",
  },
  {
    number: 1,
    firstName: "Lotta",
    lastName: "Reichardt",
    birthday: "2011-06-06",
    isGoalkeeper: false,
    teamShortName: "rbl",
  },
  {
    number: 2,
    firstName: "Zoe",
    lastName: "Schwaß",
    birthday: "2011-12-16",
    isGoalkeeper: false,
    teamShortName: "rbl",
  },
  {
    number: 3,
    firstName: "Ida",
    lastName: "Kunze",
    birthday: "2011-06-17",
    isGoalkeeper: false,
    teamShortName: "rbl",
  },
  {
    number: 4,
    firstName: "Annika",
    lastName: "Baer",
    birthday: "2011-05-26",
    isGoalkeeper: false,
    teamShortName: "rbl",
  },
  {
    number: 5,
    firstName: "Ida",
    lastName: "Proft",
    birthday: "2011-04-16",
    isGoalkeeper: false,
    teamShortName: "rbl",
  },
  {
    number: 6,
    firstName: "Josefine",
    lastName: "Uhlig",
    birthday: "2012-03-31",
    isGoalkeeper: false,
    teamShortName: "rbl",
  },
  {
    number: 10,
    firstName: "Liya",
    lastName: "Jakob",
    birthday: "2011-07-05",
    isGoalkeeper: false,
    teamShortName: "rbl",
  },
  {
    number: 11,
    firstName: "Frederike",
    lastName: "Martens",
    birthday: "2012-01-17",
    isGoalkeeper: false,
    teamShortName: "rbl",
  },
  {
    number: 15,
    firstName: "Käte",
    lastName: "Münchow",
    birthday: "2011-06-16",
    isGoalkeeper: false,
    teamShortName: "rbl",
  },
  {
    number: 19,
    firstName: "Paula",
    lastName: "Cubota Ruiz-Viana",
    birthday: "2011-06-19",
    isGoalkeeper: false,
    teamShortName: "rbl",
  },
  {
    number: 25,
    firstName: "Paula",
    lastName: "Schöley",
    birthday: "2011-12-04",
    isGoalkeeper: false,
    teamShortName: "rbl",
  },
  {
    number: 1,
    firstName: "Hanna",
    lastName: "Alshami",
    birthday: "2012-12-24",
    isGoalkeeper: true,
    teamShortName: "hsv",
  },
  {
    number: 5,
    firstName: "Amy",
    lastName: "Niemann",
    birthday: "2012-04-19",
    isGoalkeeper: false,
    teamShortName: "hsv",
  },
  {
    number: 6,
    firstName: "Leni",
    lastName: "Pereira da Silva",
    birthday: "2011-08-15",
    isGoalkeeper: false,
    teamShortName: "hsv",
  },
  {
    number: 7,
    firstName: "Marie",
    lastName: "Wallbaum",
    birthday: "2011-05-06",
    isGoalkeeper: false,
    teamShortName: "hsv",
  },
  {
    number: 8,
    firstName: "Lilli",
    lastName: "Hintelmann",
    birthday: "2011-04-26",
    isGoalkeeper: false,
    teamShortName: "hsv",
  },
  {
    number: 9,
    firstName: "Lene",
    lastName: "Nickel",
    birthday: "2012-08-13",
    isGoalkeeper: false,
    teamShortName: "hsv",
  },
  {
    number: 10,
    firstName: "Lina",
    lastName: "Dau-Schmidt",
    birthday: "2012-03-20",
    isGoalkeeper: false,
    teamShortName: "hsv",
  },
  {
    number: 11,
    firstName: "Leni",
    lastName: "Hesse",
    birthday: "2011-05-05",
    isGoalkeeper: false,
    teamShortName: "hsv",
  },
  {
    number: 16,
    firstName: "Charlotte",
    lastName: "Black",
    birthday: "2011-05-30",
    isGoalkeeper: false,
    teamShortName: "hsv",
  },
  {
    number: 17,
    firstName: "Frieda",
    lastName: "Keick",
    birthday: "2011-03-16",
    isGoalkeeper: false,
    teamShortName: "hsv",
  },
  {
    number: 18,
    firstName: "Enna",
    lastName: "Luckow",
    birthday: "2011-10-12",
    isGoalkeeper: false,
    teamShortName: "hsv",
  },
  {
    number: 1,
    firstName: "Ina",
    lastName: "Lützow",
    birthday: "2011-08-17",
    isGoalkeeper: false,
    teamShortName: "fcu",
  },
  {
    number: 3,
    firstName: "Edina",
    lastName: "Gjebegji",
    birthday: "2012-02-16",
    isGoalkeeper: false,
    teamShortName: "fcu",
  },
  {
    number: 6,
    firstName: "Mila",
    lastName: "Wiedleroither",
    birthday: "2011-12-11",
    isGoalkeeper: false,
    teamShortName: "fcu",
  },
  {
    number: 7,
    firstName: "Florentine",
    lastName: "Kruss",
    birthday: "2011-02-10",
    isGoalkeeper: false,
    teamShortName: "fcu",
  },
  {
    number: 8,
    firstName: "Lucy",
    lastName: "Bleitgen",
    birthday: "2011-06-07",
    isGoalkeeper: false,
    teamShortName: "fcu",
  },
  {
    number: 9,
    firstName: "Milou",
    lastName: "Flory",
    birthday: "2011-02-15",
    isGoalkeeper: false,
    teamShortName: "fcu",
  },
  {
    number: 10,
    firstName: "Kashia",
    lastName: "Brabandt",
    birthday: "2011-08-29",
    isGoalkeeper: false,
    teamShortName: "fcu",
  },
  {
    number: 11,
    firstName: "Hanna",
    lastName: "Wiegner",
    birthday: "2012-09-02",
    isGoalkeeper: false,
    teamShortName: "fcu",
  },
  {
    number: 18,
    firstName: "Leonie",
    lastName: "Kaul",
    birthday: "2011-04-08",
    isGoalkeeper: false,
    teamShortName: "fcu",
  },
  {
    number: 22,
    firstName: "Amelia",
    lastName: "Neumann",
    birthday: "2012-08-11",
    isGoalkeeper: false,
    teamShortName: "fcu",
  },
  {
    number: 1,
    firstName: "Ida",
    lastName: "Heitzig",
    birthday: "2011-09-08",
    isGoalkeeper: false,
    teamShortName: "b04",
  },
  {
    number: 22,
    firstName: "Maja",
    lastName: "Lomaszki",
    birthday: "2012-07-10",
    isGoalkeeper: false,
    teamShortName: "b04",
  },
  {
    number: 2,
    firstName: "Martha",
    lastName: "Althof",
    birthday: "2011-07-07",
    isGoalkeeper: false,
    teamShortName: "b04",
  },
  {
    number: 3,
    firstName: "Carlotta",
    lastName: "Schmitz",
    birthday: "2012-04-04",
    isGoalkeeper: false,
    teamShortName: "b04",
  },
  {
    number: 6,
    firstName: "Berfin",
    lastName: "Kilit",
    birthday: "2011-02-07",
    isGoalkeeper: false,
    teamShortName: "b04",
  },
  {
    number: 7,
    firstName: "Greta",
    lastName: "Schauff",
    birthday: "2011-09-23",
    isGoalkeeper: false,
    teamShortName: "b04",
  },
  {
    number: 16,
    firstName: "Lina",
    lastName: "Zarraa",
    birthday: "2012-05-24",
    isGoalkeeper: false,
    teamShortName: "b04",
  },
  {
    number: 17,
    firstName: "Annika",
    lastName: "Falk",
    birthday: "2012-01-14",
    isGoalkeeper: false,
    teamShortName: "b04",
  },
  {
    number: 18,
    firstName: "Ayana",
    lastName: "Heuts",
    birthday: "2012-03-04",
    isGoalkeeper: false,
    teamShortName: "b04",
  },
  {
    number: 19,
    firstName: "Charlotta",
    lastName: "Kurz",
    birthday: "2012-10-09",
    isGoalkeeper: false,
    teamShortName: "b04",
  },
  {
    number: 20,
    firstName: "Melina-Vaia",
    lastName: "Tsirimokos-Müller",
    birthday: "2012-01-02",
    isGoalkeeper: false,
    teamShortName: "b04",
  },
  {
    number: 23,
    firstName: "Emilia",
    lastName: "Golka",
    birthday: "2012-12-23",
    isGoalkeeper: false,
    teamShortName: "b04",
  },
  {
    number: 27,
    firstName: "Melisa",
    lastName: "Mustafa",
    birthday: "2012-01-22",
    isGoalkeeper: false,
    teamShortName: "b04",
  },
  {
    number: 33,
    firstName: "Ayla",
    lastName: "Ülger",
    birthday: "2012-08-06",
    isGoalkeeper: false,
    teamShortName: "b04",
  },
  {
    number: 1,
    firstName: "Clara",
    lastName: "Groß",
    birthday: "2012-02-29",
    isGoalkeeper: false,
    teamShortName: "fcc",
  },
  {
    number: 2,
    firstName: "Malina",
    lastName: "Wagner",
    birthday: "2011-09-29",
    isGoalkeeper: false,
    teamShortName: "fcc",
  },
  {
    number: 5,
    firstName: "Pia",
    lastName: "Junghans",
    birthday: "2011-05-16",
    isGoalkeeper: false,
    teamShortName: "fcc",
  },
  {
    number: 6,
    firstName: "Fiona",
    lastName: "Jäger",
    birthday: "2011-06-09",
    isGoalkeeper: false,
    teamShortName: "fcc",
  },
  {
    number: 7,
    firstName: "Celine",
    lastName: "Albrecht",
    birthday: "2012-06-08",
    isGoalkeeper: false,
    teamShortName: "fcc",
  },
  {
    number: 8,
    firstName: "Mira",
    lastName: "Wich",
    birthday: "2011-03-23",
    isGoalkeeper: false,
    teamShortName: "fcc",
  },
  {
    number: 9,
    firstName: "Lene",
    lastName: "Schaller",
    birthday: "2011-08-22",
    isGoalkeeper: false,
    teamShortName: "fcc",
  },
  {
    number: 10,
    firstName: "Lara",
    lastName: "Scheuch",
    birthday: "2011-10-20",
    isGoalkeeper: false,
    teamShortName: "fcc",
  },
  {
    number: 11,
    firstName: "Valentina",
    lastName: "Müller",
    birthday: "2012-01-03",
    isGoalkeeper: false,
    teamShortName: "fcc",
  },
  {
    number: 12,
    firstName: "Stella",
    lastName: "Dolzer",
    birthday: "2013-09-29",
    isGoalkeeper: false,
    teamShortName: "fcc",
  },
  {
    number: 16,
    firstName: "Sophie",
    lastName: "Beyer",
    birthday: "2011-01-10",
    isGoalkeeper: false,
    teamShortName: "fcc",
  },
  {
    number: 18,
    firstName: "Naya",
    lastName: "Koch",
    birthday: "2012-11-01",
    isGoalkeeper: false,
    teamShortName: "fcc",
  },
  {
    number: 19,
    firstName: "Charlotte",
    lastName: "Burkhardt",
    birthday: "2012-04-15",
    isGoalkeeper: false,
    teamShortName: "fcc",
  },
  {
    number: 21,
    firstName: "Marisa",
    lastName: "Marchio",
    birthday: "2011-03-31",
    isGoalkeeper: false,
    teamShortName: "fcc",
  },
  {
    number: 1,
    firstName: "Mia",
    lastName: "Kohnen",
    birthday: "2011-03-22",
    isGoalkeeper: false,
    teamShortName: "bmg",
  },
  {
    number: 3,
    firstName: "Claire",
    lastName: "Hücking",
    birthday: "2012-03-09",
    isGoalkeeper: false,
    teamShortName: "bmg",
  },
  {
    number: 5,
    firstName: "Margaretha",
    lastName: "Gerckens",
    birthday: "2012-05-11",
    isGoalkeeper: false,
    teamShortName: "bmg",
  },
  {
    number: 6,
    firstName: "Anna-Maria",
    lastName: "Oeltjen",
    birthday: "2011-04-21",
    isGoalkeeper: false,
    teamShortName: "bmg",
  },
  {
    number: 7,
    firstName: "Luisa",
    lastName: "Leven",
    birthday: "2012-02-10",
    isGoalkeeper: false,
    teamShortName: "bmg",
  },
  {
    number: 8,
    firstName: "Lotta",
    lastName: "Feldmann",
    birthday: "2011-11-07",
    isGoalkeeper: false,
    teamShortName: "bmg",
  },
  {
    number: 9,
    firstName: "Jada",
    lastName: "Emans",
    birthday: "2011-07-02",
    isGoalkeeper: false,
    teamShortName: "bmg",
  },
  {
    number: 10,
    firstName: "Indah",
    lastName: "Trienekens",
    birthday: "2011-09-12",
    isGoalkeeper: false,
    teamShortName: "bmg",
  },
  {
    number: 11,
    firstName: "Malak",
    lastName: "Sawli",
    birthday: "2012-06-30",
    isGoalkeeper: false,
    teamShortName: "bmg",
  },
  {
    number: 12,
    firstName: "Anne",
    lastName: "Puppe",
    birthday: "2012-01-29",
    isGoalkeeper: false,
    teamShortName: "bmg",
  },
  {
    number: 13,
    firstName: "Mia",
    lastName: "Otschik",
    birthday: "2012-07-04",
    isGoalkeeper: false,
    teamShortName: "bmg",
  },
  {
    number: 14,
    firstName: "Clara",
    lastName: "Cox",
    birthday: "2012-04-27",
    isGoalkeeper: false,
    teamShortName: "bmg",
  },
  {
    number: 15,
    firstName: "Mieke",
    lastName: "Moonen",
    birthday: "2012-03-28",
    isGoalkeeper: false,
    teamShortName: "bmg",
  },
  {
    number: 16,
    firstName: "Leonie",
    lastName: "Herbst",
    birthday: "2011-12-20",
    isGoalkeeper: false,
    teamShortName: "bmg",
  },
  {
    number: 17,
    firstName: "Laura",
    lastName: "Berg",
    birthday: "2011-12-16",
    isGoalkeeper: false,
    teamShortName: "bmg",
  },
  {
    number: 18,
    firstName: "Mila",
    lastName: "Schlechtriem",
    birthday: "2012-09-03",
    isGoalkeeper: false,
    teamShortName: "bmg",
  },
  {
    number: 19,
    firstName: "Mette",
    lastName: "Meessen",
    birthday: "2011-01-15",
    isGoalkeeper: false,
    teamShortName: "bmg",
  },
  {
    number: 20,
    firstName: "Anna",
    lastName: "Kahlert",
    birthday: "2011-09-13",
    isGoalkeeper: false,
    teamShortName: "bmg",
  },
  {
    number: 1,
    firstName: "Mara",
    lastName: "Jänig",
    birthday: "2012-11-06",
    isGoalkeeper: true,
    teamShortName: "wob",
  },
  {
    number: 3,
    firstName: "Aurora",
    lastName: "Vanella",
    birthday: "2012-05-02",
    isGoalkeeper: false,
    teamShortName: "wob",
  },
  {
    number: 8,
    firstName: "Lotta-Marit",
    lastName: "Meier",
    birthday: "2012-09-04",
    isGoalkeeper: false,
    teamShortName: "wob",
  },
  {
    number: 9,
    firstName: "Maria",
    lastName: "Pencheva",
    birthday: "2012-02-24",
    isGoalkeeper: false,
    teamShortName: "wob",
  },
  {
    number: 10,
    firstName: "Nele",
    lastName: "Müller",
    birthday: "2011-09-19",
    isGoalkeeper: false,
    teamShortName: "wob",
  },
  {
    number: 11,
    firstName: "Kornelia",
    lastName: "Chojnacki",
    birthday: "2012-09-16",
    isGoalkeeper: false,
    teamShortName: "wob",
  },
  {
    number: 12,
    firstName: "Isabella",
    lastName: "Ehlers",
    birthday: "2011-02-03",
    isGoalkeeper: true,
    teamShortName: "wob",
  },
  {
    number: 13,
    firstName: "Lea",
    lastName: "Zillmer",
    birthday: "2011-06-07",
    isGoalkeeper: false,
    teamShortName: "wob",
  },
  {
    number: 14,
    firstName: "Joelina",
    lastName: "Elfert",
    birthday: "2011-05-14",
    isGoalkeeper: false,
    teamShortName: "wob",
  },
  {
    number: 15,
    firstName: "Mara",
    lastName: "Conrad",
    birthday: "2011-06-29",
    isGoalkeeper: false,
    teamShortName: "wob",
  },
  {
    number: 16,
    firstName: "Ruth-Maria",
    lastName: "Sticherling",
    birthday: "2012-05-14",
    isGoalkeeper: false,
    teamShortName: "wob",
  },
  {
    number: 17,
    firstName: "Nikolina",
    lastName: "Stupar",
    birthday: "2013-02-04",
    isGoalkeeper: false,
    teamShortName: "wob",
  },
  {
    number: 18,
    firstName: "Emma",
    lastName: "Schade",
    birthday: "2011-05-16",
    isGoalkeeper: false,
    teamShortName: "wob",
  },
  {
    number: 19,
    firstName: "Frieda",
    lastName: "Wucherpfennig",
    birthday: "2012-09-18",
    isGoalkeeper: false,
    teamShortName: "wob",
  },
  {
    number: 20,
    firstName: "Yara",
    lastName: "König",
    birthday: "2011-03-21",
    isGoalkeeper: false,
    teamShortName: "wob",
  },
  {
    number: 21,
    firstName: "Isabella",
    lastName: "Scholz",
    birthday: "2011-09-10",
    isGoalkeeper: false,
    teamShortName: "wob",
  },
];
